import React from "react";
import "../styles/whyus.css";
import pizzaIcon from "../assets/pizza-icon.svg";

function FranchiseBlock({
  title,
  text,
  bullets,
  image,
  imageLeft = true,
  textafter,
}) {
  return (
    <div className="row align-items-center g-5 mb-5 px-4">
      {/* IMAGE */}
      <div className={`col-lg-6 ${imageLeft ? "" : "order-lg-2"}`}>
        <div className="whyus-image-wrap">
          <img src={image} alt={title} className="whyus-image" loading="lazy" />
        </div>
      </div>

      {/* TEXT */}
      <div
        className={`col-lg-6 ${imageLeft ? "" : "order-lg-1"} d-flex justify-content-center`}
      >
        <div
          className="whyus-content text-center"
          style={{ maxWidth: "520px" }}
        >
          <h2 dangerouslySetInnerHTML={{ __html: title }} />

          {text.map((p, i) => (
            <p key={i} dangerouslySetInnerHTML={{ __html: p }} />
          ))}

          {bullets && (
            <ul className="whyus-list">
              {bullets.map((b, i) => (
                <li key={`b-${i}`}>
                  <img src={pizzaIcon} alt="" className="icon" />
                  {typeof b === "string" ? (
                    b
                  ) : (
                    <a
                      href={b.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="franchise-link"
                    >
                      {b.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          )}

          {textafter.map((p, i) => (
            <p
              key={i}
              className="pt-3"
              dangerouslySetInnerHTML={{ __html: p }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default function Franchise() {
  return (
    <section className="whyus-section">
      <div className="container py-5">
        {/* HEADER */}
        <div className="gyros-header">
          <h2>
            Pizza Home <span className="highlight-red">franchise</span> – egy
            működő rendszer,{" "}
            <span className="highlight-red">valódi eredményekkel</span>
          </h2>
        </div>

        {/* BLOCK 1 */}
        <FranchiseBlock
          image="/images/menu/pizzas/pizza-1.webp"
          imageLeft
          title={`Nem elmélet, hanem <span class="highlight">bizonyított működés</span>`}
          text={[
            `A Pizza Home franchise nem egy elméleti üzleti modell, hanem egy évek óta bizonyító, aktívan működő pizzéria rendszer.`,
            `A franchise alapját a <a class="franchise-link" href="https://szolnokipizza.hu" target="_blank" rel="noopener noreferrer">Pizza Home Szolnok</a> sikeres működése adja, amelynek tapasztalatai az egri egységben is megvalósultak.`,
          ]}
          textafter={[]}
        />

        {/* BLOCK 2 */}
        <FranchiseBlock
          image="/images/menu/pizzas/pizza-2.webp"
          imageLeft={false}
          title={`Mit jelent a Pizza Home <span class="highlight">franchise</span> a gyakorlatban?`}
          text={[
            "A Pizza Home franchise nem egy merev sablon, hanem egy kiforrott, mégis rugalmas rendszer.",
            "A franchise modell fő pillérei:",
          ]}
          bullets={[
            "Bevált termékkínálat és receptúra",
            "Optimalizált konyhai és kiszállítási folyamatok",
            "Egységes arculat és erős márkanév",
            "Kipróbált működési struktúra",
            "Folyamatos tudásmegosztás a partnerek között",
          ]}
          textafter={[
            "A cél az, hogy a franchise partnerek gyorsabban, kevesebb kockázattal és kiszámíthatóbban működjenek.",
          ]}
        />

        {/* BLOCK 3 */}
        <FranchiseBlock
          image="/images/menu/pizzas/pizza-3.webp"
          imageLeft
          title={`Nem csak termelés – <span class="highlight">értékesítés is</span>`}
          text={[
            "A Pizza Home franchise egyik legnagyobb előnye az értékesítési támogatás.",
            "Ez azt jelenti, hogy a franchise partnerek:",
          ]}
          bullets={[
            "Nem kell vakon kísérletezni",
            "Nem kell minden marketingmegoldást külön kitapasztalni",
            "Már működő értékesítési logika alapján működnek",
          ]}
          textafter={[
            "A Pizza Home esetében a jó termék és a forgalom kéz a kézben jár.",
          ]}
        />

        {/* BLOCK 4 */}
        <FranchiseBlock
          image="/images/menu/pizzas/pizza-4.webp"
          imageLeft={false}
          title={`Online marketing <span class="highlight">támogatás</span>`}
          text={[
            "A franchise partnerek kézzelfogható online marketing támogatást kapnak.",
            "A támogatás kiterjed:",
          ]}
          bullets={[
            "SEO-optimalizált weboldal struktúrákra",
            "Online rendelési folyamatokra",
            "Helyi online jelenlét erősítésére",
            "Bevált kommunikációs és hirdetési irányokra",
          ]}
          textafter={["Ennek eredménye a kiszámítható, stabil forgalom."]}
        />

        {/* BLOCK 5 */}
        <FranchiseBlock
          image="/images/menu/pizzas/pizza-5.webp"
          imageLeft
          title={`Közös beszállítók és <span class="highlight">országos szolgáltatók</span>`}
          text={[
            "Az egységek ugyanazokat a beszállítókat és szolgáltatókat használják.",
            "Ez jelentős előnyt biztosít:",
          ]}
          bullets={[
            "Kedvezőbb beszerzési feltételek",
            "Stabil alapanyag-ellátás",
            "Egységes minőség minden városban",
            "Hatékony együttműködés",
          ]}
          textafter={[
            "Egy franchise rendszerben ezek az előnyök összeadódnak.",
          ]}
        />

        {/* BLOCK 6 */}
        <FranchiseBlock
          image="/images/menu/pizzas/pizza-1.webp"
          imageLeft={false}
          title={`Közös alapok, <span class="highlight">helyi erősségek</span>`}
          text={[
            "A közös rendszer mellett minden város a saját piacához igazodik.",
            "Ez biztosítja:",
          ]}
          bullets={[
            "Egységes márkát",
            "Helyi igényekhez illeszkedő kommunikációt",
            "Hosszú távú versenyképességet",
          ]}
          textafter={[
            `A <a class="franchise-link" href="https://szolnokipizza.hu" target="_blank" rel="noopener noreferrer">Szolnoki Pizza Home</a> és az <a class="franchise-link" href="https://pizzaeger.hu" target="_blank" rel="noopener noreferrer">Egri Pizza Home</a> egységek egymást erősítik.`,
          ]}
        />

        {/* BLOCK 7 */}
        <FranchiseBlock
          image="/images/menu/pizzas/pizza-2.webp"
          imageLeft
          title={`Miért <span class="highlight">Pizza Home franchise?</span>`}
          text={[]}
          bullets={[
            "Valós üzleti tapasztalat",
            "Több éve működő rendszer",
            "Erős online marketing háttér",
            "Közös beszerzés",
            "Folyamatos támogatás",
          ]}
          textafter={[
            "A cél nem a gyors terjeszkedés, hanem a hosszú távú nyereségesség.",
          ]}
        />

        {/* BLOCK 8 – CTA */}
        <FranchiseBlock
          image="/images/menu/pizzas/pizza-3.webp"
          imageLeft={false}
          title={`Érdekel a <span class="highlight">Pizza Home franchise?</span>`}
          text={[
            "Ha egy bizonyított pizzéria franchise rendszerhez szeretnél csatlakozni:",
            "Ismerd meg működésünket:",
          ]}
          bullets={[
            {
              label: "Szolnokon – Pizza Home Szolnok",
              href: "https://szolnokipizza.hu",
            },
            {
              label: "Egerben – Pizza Home Eger",
              href: "https://pizzaeger.hu",
            },
          ]}
          textafter={[
            "Közös rendszer, közös tapasztalat, valódi eredmények.",
            `Kapcsolat: <a class="franchise-link" href="mailto:info@pizza-home.hu">info@pizza-home.hu</a>`,
          ]}
        />
      </div>
    </section>
  );
}
